import MoveToListConnector from './moveToList.props';
import MoveToListComponent from './moveToList.component';

export default MoveToListConnector(MoveToListComponent);
